import { api , base_url_v1 } from ".";

export const GetRollCallApi = async (start:string , end:string , page:any) => {
    const data = await api({ url: `${base_url_v1}rollcalls?from=${start}&to=${end}&page=${page}` , method: "GET" , token:true })
    return { data };
}